import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AnnouncementBanner from '../components/AnnouncementBanner';
import FloatingWhatsApp from '../components/FloatingWhatsApp';
import MobileBottomNav from '../components/MobileBottomNav';
import { CheckCircle, ArrowRight, Instagram, BookOpen } from 'lucide-react';

const nextSteps = [
  { step: 1, title: "We'll reach out within 24 hours", desc: "Our team will contact you on WhatsApp at the number you provided." },
  { step: 2, title: "Quick health & goals discussion", desc: "We'll understand your medical history and current goals." },
  { step: 3, title: "Personalized program guidance", desc: "Based on your needs, we'll recommend the right program for you." }
];

const ThankYouPage = () => {
  return (
    <div className="min-h-screen bg-slate-950">
      <Helmet>
        <title>Thank You | TCUBE FITNESS™</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <AnnouncementBanner />
      <Header />

      <main id="main-content" className="pt-32 sm:pt-36 pb-24 lg:pb-12">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-3xl mx-auto text-center">
            <div className="w-20 h-20 mx-auto mb-6 bg-emerald-500/15 rounded-3xl flex items-center justify-center border border-emerald-500/30">
              <CheckCircle className="w-10 h-10 text-emerald-400" aria-hidden="true" />
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-3" data-testid="thankyou-heading">
              You're All Set!
            </h1>
            <p className="text-slate-300 text-base sm:text-lg mb-12">
              Our team will contact you within 24 hours.
            </p>

            <div className="bg-slate-900/60 border border-slate-800 rounded-2xl p-6 sm:p-8 text-left mb-10">
              <h2 className="text-xl sm:text-2xl font-bold text-white mb-5 text-center">What Happens Next</h2>
              <ol className="space-y-4">
                {nextSteps.map((s) => (
                  <li key={s.step} className="flex gap-4">
                    <div className="w-8 h-8 bg-gradient-to-r from-blue-600 to-cyan-600 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0">
                      {s.step}
                    </div>
                    <div>
                      <h3 className="text-white font-semibold text-sm sm:text-base mb-0.5">{s.title}</h3>
                      <p className="text-slate-400 text-sm">{s.desc}</p>
                    </div>
                  </li>
                ))}
              </ol>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a
                href="https://www.instagram.com/tcubefitness/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-pink-600 to-rose-600 hover:from-pink-500 hover:to-rose-500 text-white px-6 py-3 rounded-full font-semibold text-sm transition-all"
                data-testid="thankyou-instagram-btn"
              >
                <Instagram className="w-4 h-4" aria-hidden="true" />
                Follow on Instagram
              </a>
              <Link
                to="/blog"
                className="inline-flex items-center justify-center gap-2 bg-slate-800 hover:bg-slate-700 text-white px-6 py-3 rounded-full font-semibold text-sm transition-all"
                data-testid="thankyou-blog-btn"
              >
                <BookOpen className="w-4 h-4" aria-hidden="true" />
                Read Health Articles
                <ArrowRight className="w-4 h-4" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </main>

      <Footer />
      <FloatingWhatsApp />
      <MobileBottomNav />
    </div>
  );
};

export default ThankYouPage;
